import { Component, OnInit, OnDestroy, AfterViewInit, Input, NgZone, ElementRef, ViewChild } from "@angular/core";
import { Title, Meta, DomSanitizer } from "@angular/platform-browser";
import {ViewportScroller} from "@angular/common";
import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes,
  query,
  stagger,
  group,
  sequence,
  AnimationBuilder,
} from "@angular/animations";
import { Router } from "@angular/router";

@Component({
    /*%SELECTOR%*/
    templateUrl: "./PageComponent___layout_component.html",
    styleUrls: ["./PageComponent___layout_component.scss"],
    host: {
        /*%HOST%*/
    },
    animations: [
        /*%ANIMATIONS%*/
    ],
})
export class PageComponent___layout implements OnInit, OnDestroy, AfterViewInit {
    constructor(private title: Title,
                private meta: Meta,
                public sanitizer: DomSanitizer,
	            public viewportScroller: ViewportScroller,
                private ngZone: NgZone,
                private elementRef: ElementRef,
                public animationBuilder: AnimationBuilder,
                public router: Router,
    ) { }
    
    ngOnInit(): void {
        /*%INIT%*/
    }

    ngAfterViewInit(): void {
        /*%DISPLAYED%*/
    }

    ngOnDestroy(): void {
        /*%DESTROY%*/
    }

    /*%BODY%*/
}
